






























































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import CurrentTime from '@/models/current-time/CurrentTime'
import { create as createCurrentTime } from '@/models/current-time/functions'

import { Sku } from './model/item'
import { ApparelAddToCartSelectionState } from './selection-state'
import { SkuStatusLabelUiText } from './ui-text/sku-status-label'

@Component({
  components: {
  },
})
export default class SizeSelection extends Vue {
  @Prop({ required: true })
  state: ApparelAddToCartSelectionState

  @Prop({ default: () => createCurrentTime() })
  current: CurrentTime

  @Prop({ required: true })
  instanceId: string

  @Prop({ required: true })
  skuStatusLabelText: SkuStatusLabelUiText

  /**
   * 全てのFKUが単一のサイズしか持たないとき、サイズ選択のUIは不要なので非表示にする
   */
  get shouldShow(): boolean {
    return !this.state.fkuList.every(fku => fku.skuList.length === 1)
  }

  get skuList(): Sku[] {
    return this.state.selectedFku.fold(
      [],
      fku => fku.skuList
    )
  }

  get sizeInputName(): string {
    return `apparel-add-to-cart-size-${this.instanceId}`
  }

  isSelectedSku(skuId: string): boolean {
    return this.state.selectedSku.map(s => s.id).toNullable() === skuId
  }

  /**
   * サイズ表記に併記するラベル
   * - 在庫の煽り表示
   * - 新作リクエスト、再入荷リクエスト受付状態
   * - 入荷待ち状態
   * - 売り切れ
   *
   * サイズの一覧を閲覧した際に在庫の状態（煽り）や現在購入できるサイズがどれであるかひと目で分かるようにする目的。
   * サイズを選択すればボタンが適切な表記に変更されるが、サイズを選んでも購入できない（在庫切れなど）場合などで、
   * サイズを選んで初めて在庫切れ（＝ユーザーは何もできない）ということがないよう、フィードバックを早める意図もある。
   */
  statusLabel(sku: Sku): string | null {
    switch (sku.resolveSalesStatus(this.current.now)) {
      case 'standard-order':
        return sku.stockText || null
      case 'restock-request':
        return this.skuStatusLabelText.restockRequest
      case 'new-arrival-request':
        return this.skuStatusLabelText.newArrivalRequest
      case 'coming-soon':
        return this.skuStatusLabelText.comingSoon
      case 'sold-out':
        return this.skuStatusLabelText.soldOut
      case 'pre-order': // 現状は予約購入で在庫煽りはない仕様
      case 'none':
      default:
        return null
    }
  }

  sizeInputId(skuId: string): string {
    return `${this.sizeInputName}-${skuId}`
  }

  onChange(sku: Sku) {
    if (this.isSelectedSku(sku.id)) {
      return
    }

    this.$emit('select-sku', sku)
  }
}
